export * from './lib/how-to.component';
